import { Stack } from '@mui/material';
import { SectionsCollapseSP111 } from '@pages/cameras/hook/useMilesightSP111';
import { ComponentType, Fragment } from 'react';
import SP111_LimitsMilesightsCameraSP111 from './components/SP111_LimitsMilesightsCameraSP111';
import InitialPositionMilesightsCameraSP111 from './components/InitialPositionMilesightsCameraSP111';
import AutoTrackingMilesightsCameraSP111 from './components/AutoTrackingMilesightsCameraSP111';
import VideoMilesightsCameraSP111 from './components/VideoMilesightsCameraSP111';
import ImageGeneralMilesightsCameraSP111 from './components/ImageGeneralMilesightsCameraSP111';
import StorageMilesightsCameraSP111 from './components/StorageMilesightsCameraSP111';
import MotionDetectionMilesightsCameraSP111 from './components/MotionDetectionMilesightsCameraSP111';
import DateAndTimeMilesightsCameraSP111 from './components/DateAndTimeMilesightsCameraSP111';

interface SectionProps {
    isOpenCollapse: { [key in SectionsCollapseSP111]: boolean };
    handleToggleCollapse: (section: SectionsCollapseSP111) => void;
}

type SectionComponent = ComponentType<SectionProps>;

const sections: SectionComponent[] = [
    SP111_LimitsMilesightsCameraSP111,
    InitialPositionMilesightsCameraSP111,
    AutoTrackingMilesightsCameraSP111,
    VideoMilesightsCameraSP111,
    ImageGeneralMilesightsCameraSP111,
    StorageMilesightsCameraSP111,
    MotionDetectionMilesightsCameraSP111,
    DateAndTimeMilesightsCameraSP111,
];

type Props = {
    isOpenCollapse: { [key in SectionsCollapseSP111]: boolean };
    handleToggleCollapse: (section: SectionsCollapseSP111) => void;
};

export default function MileSightSP111Page({ isOpenCollapse, handleToggleCollapse }: Props) {
    return (
        <Stack width="100%" direction="column" spacing={2}>
            {sections.map((Component, index) => (
                <Fragment key={index}>
                    <Component isOpenCollapse={isOpenCollapse} handleToggleCollapse={handleToggleCollapse} />
                </Fragment>
            ))}
        </Stack>
    );
}
